import { render, staticRenderFns } from "./IdeasLayout.vue?vue&type=template&id=73051270&scoped=true&"
import script from "./IdeasLayout.vue?vue&type=script&lang=js&"
export * from "./IdeasLayout.vue?vue&type=script&lang=js&"
import style0 from "./IdeasLayout.vue?vue&type=style&index=0&id=73051270&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73051270",
  null
  
)

export default component.exports